import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getMachineById } from '../../../../api/machine/queries/getMachineById';
import { IMachine } from '../../../../interfaces/Machine.interfaces';

interface IUseGetMachineByIdQueryParams {
  machineId: string;
}

export const useGetMachineByIdQuery = ({ machineId }: IUseGetMachineByIdQueryParams) => {
  return useQuery<IMachine, AxiosError>(['machine_by_id', machineId], () => getMachineById({ machineId }), {
    enabled: Boolean(machineId),
  });
};
